
  import { Component, PropSync, Vue } from "vue-property-decorator";
  import { inject } from "inversify-props";
  import { ISiteService } from "@/services";
  import { MealCountDtoViewModel } from '@/view-models';
  import { ObjectHelper } from "@/utils";

  @Component
  export default class McSummary extends Vue {
    @inject() siteService!: ISiteService;
    @PropSync("model", { type: Object }) modelSync!: MealCountDtoViewModel;
    @PropSync("fluent") fluentValidate!: any;

    get boolForServeCountsValidation(): boolean {
      return ObjectHelper.keyExists(this.fluentValidate, 'servingLines');
    }
    get boolForReceivingDateValidation(): boolean {
      return ObjectHelper.keyExists(this.fluentValidate, 'deliveryDate');
    }
  }
